// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewCommentsList.test.tsx
import { useTranslation } from "react-i18next";

import { type ReviewListTab } from "./useReviewListView";

import { SlidingSegmentedControl } from "../../components/SlidingSegmentedControl";

export type AskV2ReviewStatusTabsProps = {
  tab: ReviewListTab;
  counts: { toDecide: number; all: number };
  onChange: (tab: ReviewListTab) => void;
};

/** To decide (the comments with no status yet) or All, each with its count. */
export function AskV2ReviewStatusTabs({
  tab,
  counts,
  onChange,
}: AskV2ReviewStatusTabsProps) {
  const { t } = useTranslation("ui");
  return (
    <SlidingSegmentedControl
      value={tab}
      onChange={onChange}
      ariaLabel={t("askV2.review.statusTabsLabel")}
      data-testid="ask-v2-review-status-tabs"
      thumbTestId="ask-v2-review-status-tabs-thumb"
      items={[
        {
          id: "toDecide",
          testId: "ask-v2-review-status-tab-to-decide",
          content: t("askV2.review.statusTabToDecide", {
            count: counts.toDecide,
          }),
        },
        {
          id: "all",
          testId: "ask-v2-review-status-tab-all",
          content: t("askV2.review.statusTabAll", { count: counts.all }),
        },
      ]}
    />
  );
}
